import { withChartLayout } from 'components/common';
import Laboratory from 'components/features/chart/order-entry/laboratory/Laboratory';

const LaboratoryPage = withChartLayout('Laboratory')(Laboratory);
export default LaboratoryPage;
